// The shared Button carries dialog layout margins that its className cannot override, so these buttons reuse its
// colours, radius, shadow and focus ring on their own.
const focusRing = 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
const outlined = `rounded-md border border-gray-300 shadow-sm bg-white text-gray-700 ${focusRing}`

export const textButton = `${outlined} px-3 py-1.5 text-sm font-medium hover:bg-gray-50`
export const stepButton = `${outlined} flex items-center justify-center p-1.5 hover:bg-gray-50`
export const unavailableStepButton = `${outlined} flex items-center justify-center p-1.5 cursor-not-allowed opacity-40`
export const retryButton = `rounded-md border border-red-300 shadow-sm bg-white px-3 py-1 font-medium hover:bg-gray-50 ${focusRing}`
